import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `HeaderRowsDirective` represent a header rows of the react Schedule.
 * It must be contained in a Schedule component(`SchduleComponent`).
 * ```tsx
 * <ScheduleComponent>
 *  <HeaderRowsDirective>
 *   <HeaderRowDirective option='Week'></HeaderRowDirective>
 *   <HeaderRowDirective option='Date'></HeaderRowDirective>
 *  <HeaderRowsDirective>
 * </ScheduleComponent>
 * ```
 */
export class HeaderRowDirective extends ComplexBase {
}
HeaderRowDirective.moduleName = 'headerRow';
export class HeaderRowsDirective extends ComplexBase {
}
HeaderRowsDirective.propertyName = 'headerRows';
HeaderRowsDirective.moduleName = 'headerRows';
